import { CachedItem } from "@lib-shared/lib";
import { Key } from "core/constants";
import { getErrorMessage, logApiError } from "core/lib";
import BusinessDetailsSummary from "core/models/business-details-summary";
import CustomerAccountService from "core/services/cef/customer-account.service";
import { CustomerAccountDetails } from "core/types/business-details";
import BusinessDetailsStore from "./business-details.store";

class BusinessDetailsStoreManager {
    store: BusinessDetailsStore;

    private _cache = new CachedItem(Key.businessDetails);

    constructor(store: BusinessDetailsStore) {
        this.store = store;
    }

    reset() {
        console.log("Resetting");
        this._cache.clear();
        this.store.reset();
    }

    populateAsync = async () => {
        if (this.store.isLoading) {
            // console.log("Skip - Loading");
            return;
        }

        this.store.updateIsLoading(true);

        if (this._cache.isCached) {
            console.log("Using cached business details");

            const cachedValue = this._cache.value;
            this.store.updateBusinessDetails(cachedValue);
            this.store.updateIsLoading(false);
            return;
        }

        try {
            console.log("Fetching customer business details");

            const response = await new CustomerAccountService().getCustomerAccount();

            const summary = new BusinessDetailsSummary(response?.data as CustomerAccountDetails);

            this.store.updateBusinessDetails(summary);
            this._cache.set(summary);
        } catch (error) {
            logApiError(error);

            const firstError = getErrorMessage(error);

            this.store.updateHasError(true, firstError);
        }

        this.store.updateIsLoading(false);
    };
}

export default BusinessDetailsStoreManager;
